<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          description="Aclaraciones sobre el motivo del cierre">
          <b-form-textarea
            id="observaciones"
            v-model="$v.observaciones.$model" 
            rows="5"
            max-rows="5"
            :state="observacionesValidas"
            @blur.native="validate">
          </b-form-textarea>
          <b-form-invalid-feedback id="observacionesFeedback">
            {{ observacionesInvalidasMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import { maxLength, required, requiredIf } from 'vuelidate/lib/validators';
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  name: 'Cierre',
  components: {
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  props: {
    requiereObservacionesCierre: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      observaciones: '',

      noValidar: true,
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      labelCols: 2,
    }
  },
  computed: {
  },
  created() {
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.required) {
            this.observacionesInvalidasMsj = 'Debe ingresar el motivo de cierre de un presupuesto con saldo';
          } else if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres';
          }      
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      let save = true;
      
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          let params = {
            observaciones: this.observaciones.trim(),
          }
          this.$emit('cerrarPresupuesto', params)
        }
      }
    },
    cancelar() {
      this.$emit('cancelarCierre')
    },
  },
  validations: {
    observaciones: {
      required: requiredIf(function () {
          return this.requiereObservacionesCierre;
        }),
      maxLength: maxLength(5000)
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
